import TabGroupBancoDoAuto from '@/components/molecules/TabGroupBancoDoAuto';
import { BancoDoAutoTabs } from '@/data/misc/banco-do-auto-tabs';

export default function BancoDoAutoPage() {
  return <TabGroupBancoDoAuto tab={BancoDoAutoTabs['banco-do-auto'].id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
